import { useState } from 'react'
import styled from '@emotion/styled'
import Coinbase from './Coinbase'
import Stripe from './stripe'

const ButtonContainer = styled.div`
  & > * {
    margin-top: 10px;
    &:first-child {
      margin-top: 0px;
    }
  }
`

const Checkout = ({ userName, cartItems }) => {
  return (
    <div>
      <div className="checkout"><span>Checkout with</span></div>
      <hr />
      <ButtonContainer>
        <Coinbase userName={userName} cartItems={cartItems} />
      </ButtonContainer>
    </div>
  );
};

export default Checkout;